<template>
  <vx-card class="p-6">
    <ValidationObserver ref="observer" v-slot="{ invalid }">
      <ValidationProvider rules="required" name="DNA Code" v-slot="{ errors }" tag="div">
        <label for="" class="vs-input--label">DNA Code</label>
        <vs-textarea v-model="inputData" class="w-full" rows="15" />
        <span class="text-danger text-sm" v-show="errors">{{ errors[0] }}</span>
      </ValidationProvider>

      <vs-button class="mr-6" @click="handleSubmit" :disabled="invalid">Submit</vs-button>
    </ValidationObserver>
  </vx-card>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { mapActions, mapState } from 'vuex';

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      inputData: '',
    };
  },
  methods: {
    async handleSubmit() {
      const isValid = await this.$refs.observer.validate();

      if (isValid) {
        return this.submit();
      }

      return this.$vs.dialog({
        color: 'danger',
        title: `Validation Error!`,
        text: 'There is a error in this form',
      });
    },
    async submit() {
      const dnaCodes = this.inputData.split(/^/gm).map(x => x.replace(/\s/g, ''));
      console.log(dnaCodes);
      return this.$vs.dialog({
        color: 'primary',
        title: `Are you sure submit?`,
        text: `There are total of ${dnaCodes.length} records`,
        acceptText: 'Yes',
        accept: () => {
          return this.batchUpdateProfile({
            dnaCodes: dnaCodes
          });
        },
      });
    },
    ...mapActions({
      batchUpdateProfile: 'helloDnaProfile/batchUpdateProfile',
    }),
  },
  computed: {
    ...mapState({
      profile: ({ helloDnaProfile }) => helloDnaProfile.helloDnaProfile,
      batchUpdateHelloDnaProfile: ({ helloDnaProfile }) => helloDnaProfile.apiState.batchUpdateHelloDnaProfile,
    }),
  },
  watch: {
    'batchUpdateHelloDnaProfile.success'(value) {
      if (value) {
        this.$vs.notify({
          title: 'Successful update!',
          color: 'success',
          position: 'top-center',
        });
      }
    },
    'batchUpdateHelloDnaProfile.error'(error) {
      if (error) {
        this.$vs.notify({
          title: 'Error!',
          text: error.data.message,
          color: 'danger',
          position: 'top-center',
        });
      }
    },
  },
};
</script>

<style></style>
